import React from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import Icon from 'components/uiElements/Icon'
import { DESIGN } from './constants'
import getSkipLinkInfo from './helpers'

require('./styles.scss')

interface SkipLinksProps {
    skipLinks: string[]
    skipContext: string
}

const SkipLinks = ({ skipLinks, skipContext }: SkipLinksProps) => {
    const { t } = useTranslation()

    const skipLinksInfo = skipLinks
        .map((skipLink) => getSkipLinkInfo(skipLink, skipContext, t))
        .filter((skipLink) => skipLink.skipToText)

    return (
        <div className={classNames('SkipLinks', { positionAbsolute: skipContext === DESIGN })}>
            {skipLinksInfo.map((skipLinkInfo, index) => {
                const { skipToText, iconCode, onClick } = skipLinkInfo

                return (
                    <button
                        key={`skipLink-${skipContext}-${skipToText}`}
                        onClick={onClick}
                        id={index === 0 ? `skipLinkId-${skipContext}` : undefined}
                    >
                        <Icon code={iconCode} />
                        {skipToText}
                    </button>
                )
            })}
        </div>
    )
}

export default SkipLinks
